export enum TipologiaContenuto {
  documento = 'DOCUMENTO',
  video = 'VIDEO',
  link = 'LINK',
  empty = ''
}
